module.exports = __webpack_public_path__ + "static/media/react_and_redux1.729f06c4.md";